import React from 'react';
import { motion } from 'framer-motion';
import Marquee from 'react-fast-marquee';
import locations from '../../Data/Home/FeaturedDestination';
import { Link, useNavigate } from 'react-router-dom';
import dubai from "../../Images/International/Dubai/dubai3.jpg"


const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="relative min-h-screen bg-gradient-to-br pt-60 pb-20 from-yellow-100 to-yellow-300 overflow-hidden flex flex-col items-center justify-center p-6">
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
          {/*sun*/}
          <div className="absolute top-[180px] left-[15px] md:top-[150px] lg:top-[200px] md:left-[85px] transform -translate-x-1/2 w-[100px] h-[100px] md:w-[200px] md:h-[200px] bg-yellow-300 opacity-70 rounded-full animate-rotate-sun">
            {/*small sun*/}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[20px] h-[20px] md:w-[60px] md:h-[60px] bg-yellow-400 rounded-full animate-pulse"></div>
          </div>
          {/* waves */}
          <div className="absolute bottom-0 left-0 w-[200%] overflow-hidden animate-wave">
            <svg
              className="w-full"
              viewBox="0 0 1440 320"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#fff7d1"
                fillOpacity="0.6"
                d="M0,288L48,272C96,256,192,224,288,218.7C384,213,480,235,576,213.3C672,192,768,128,864,122.7C960,117,1056,171,1152,176C1248,181,1344,139,1392,117.3L1440,96L1440,320L0,320Z"
              />
            </svg>
          </div>

        </div>

        {/* Welcome Card */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative mt-6 z-10 bg-white/30 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/20 p-4 md:p-10 max-w-3xl text-center overflow-hidden"
        >
          <h1 className="text-4xl font-bold text-yellow-700 mb-2">Welcome to Vamika Tours</h1>
          {/* Special Deal Section */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative z-10 md:mt-16 mt-6 bg-white/40 backdrop-blur-lg rounded-3xl 
             shadow-2xl border border-white/20 p-3 md:p-10 max-w-5xl mx-auto overflow-hidden"
          >
            <h2 className="text-2xl md:text-3xl font-extrabold text-yellow-700 mb-8 text-center">
            Special Deal: DUBAI
            </h2>

            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Dubai Image */}
              <div className="md:w-1/2 w-[100%] rounded-2xl overflow-hidden shadow-lg">
                <img
                  src={dubai}
                  alt="Dubai Special Offer"
                  className="w-full h-72 object-cover hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Offer Details */}
              <div className="md:w-1/2 text-center md:text-left">
                <h3 className="text-2xl font-bold text-yellow-800 mb-3">
                  Dubai Holiday Package
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Enjoy 5 Nights & 6 Days in the heart of Dubai with Desert Safari,
                  Luxury Hotel Stay, and City Tour. Perfect for a premium getaway!
                </p>
                <p className="text-2xl font-extrabold text-red-600 mb-6">
                  🔥 Limited Offer
                </p>
                <Link
                  to="/international/Dubai"
                  className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-500 
                   text-white px-8 py-3 rounded-full shadow-md hover:shadow-xl 
                   transition-transform transform hover:scale-105 font-semibold"
                >
                  Book Now
                </Link>
              </div>
            </div>
          </motion.div>


          <h3 className="text-xl font-semibold text-yellow-600 mt-3 mb-4">Your next adventure starts here.</h3>
          <p className="text-gray-700 text-md leading-relaxed">
            We are a leading travel service organization offering a wide range of high-quality, competitively priced, and value-added products and services.
          </p>
        </motion.div>

        {/* Marquee Auto Slider */}
        <div className="relative z-10 mt-28 w-full overflow-hidden">
          <Marquee speed={50}>
            {['Manali', 'Goa', 'Jaipur', 'Kerala', 'Shimla', 'Andaman', 'Udaipur', 'Rishikesh', 'Leh Ladakh', 'Darjeeling'].map((location, index) => (
              <span key={index} className="mx-8 text-yellow-800 font-semibold text-lg">{location}</span>
            ))}
          </Marquee>
        </div>
      </div>

      {/* Featured Destinations Section */}
      <h2
        className="text-4xl font-extrabold text-center text-yellow-700 mb-12 mt-20 p-1">
        Featured Destinations
      </h2>

      <div className="flex flex-wrap justify-center items-center m-auto px-4">
        {locations.map((loc, index) => (
          <motion.div
            key={loc.id || index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            viewport={{ once: true }}
            className="w-full sm:w-72 md:w-80 lg:w-96 m-4 bg-white/40 backdrop-blur-md border border-white/20 rounded-3xl shadow-md hover:shadow-lg transition-transform transform hover:scale-105 overflow-hidden"
          >
            <div className="h-48 overflow-hidden">
              <img
                loading="lazy"
                src={loc.images[0]}
                alt={loc.title}
                className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
              />

            </div>
            <div className="p-5">
              <h3 className="text-xl font-bold text-yellow-800">{loc.title}</h3>
              <p className="text-sm text-gray-600 mt-2">{loc.description}</p>
              <p className="text-yellow-600 font-medium mt-2">{loc.tripDuration}</p>
              <Link
                to={`/location/${loc.id}`}
                className="inline-block mt-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-5 py-2 rounded-full shadow-md hover:shadow-lg transition duration-300"
              >
                View More
              </Link>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Booking Card Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        viewport={{ once: true }}
        className="bg-gradient-to-br mt-20 from-yellow-200 via-yellow-100 to-white/70 rounded-3xl shadow-lg p-12 text-center mx-6 mb-20 border border-white/20 transition-all transform hover:scale-105"
      >
        <h3 className="text-3xl font-semibold text-yellow-700 mb-6">Ready for Your Next Adventure?</h3>
        <p className="text-gray-700 mb-6 text-lg">
          Book your dream trip with us now and create unforgettable memories.
        </p>
        <button
          onClick={() => navigate('/booking')}
          className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white font-semibold px-8 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105"
        >
          Book Your Trip
        </button>
      </motion.div>
    </>
  );
};

export default Home;